// extracted by mini-css-extract-plugin
export default {"Companies":"styles_Companies__OYEQv"};